import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { graphql } from "@repo/graphql-types/gql";
import Car from "@repo/icons/default/Car";
import Left from "@repo/icons/default/Left";

import { useGraphQL } from "@/hooks/use-graphql";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import { Page } from "@/components/ui/layout/page/page";
import {
  EmptyStateRoot,
  EmptyStateIcon,
  EmptyStateTitle,
  EmptyStateDescription,
} from "@/components/ui/empty-state/empty-state";
import { Button } from "@/components/ui/button/button";
import { VehicleCard } from "@/components/vehicles/vehicle-card";

import type { JSX } from "react";

const VehiclesPageQuery = graphql(/* GraphQL */ `
  query VehiclesPageQuery {
    usuariosVeiculos(where: { dataDesativacao: { _is_null: true } }) {
      codUsuarioVeiculo
      marca
      modelo
      cor
      placa
    }
  }
`);

const VehiclesPage = (): JSX.Element => {
  const navigate = useNavigate();
  const queryResult = useGraphQL(VehiclesPageQuery);
  const { data } = queryResult;

  const vehicles = data?.usuariosVeiculos ?? [];
  const hasVehicles = vehicles.length > 0;

  const handleCreateVehicle = (): void => {
    void navigate({ to: "/settings/profile/vehicles/create" });
  };

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Veículos" align="center" />
      </HeaderRoot>
      <Page>
        <AsyncDataWrapper {...queryResult}>
          {hasVehicles ? (
            <div className="flex flex-col gap-4">
              {vehicles.map((vehicle) => (
                <VehicleCard
                  key={vehicle.codUsuarioVeiculo}
                  codUsuarioVeiculo={vehicle.codUsuarioVeiculo}
                  placa={vehicle.placa}
                  marca={vehicle.marca}
                  modelo={vehicle.modelo}
                  cor={vehicle.cor}
                />
              ))}
              <Button fullWidth onClick={handleCreateVehicle}>
                Cadastrar veículo
              </Button>
            </div>
          ) : (
            <EmptyStateRoot>
              <EmptyStateIcon icon={Car} />
              <EmptyStateTitle>Sem veículos cadastrados</EmptyStateTitle>
              <EmptyStateDescription>
                Facilite sua entrada nos estacionamentos das unidades e cadastre seu
                veículo.
              </EmptyStateDescription>
              <Button fullWidth onClick={handleCreateVehicle}>
                Cadastrar veículo
              </Button>
            </EmptyStateRoot>
          )}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/profile/vehicles/")({
  component: VehiclesPage,
});
